const React = require("react")
const { ThemeProvider } = require("styled-components")

const defaultTheme = require("./themes.js").default

exports.wrapRootElement = ({ element }) => {
  return <ThemeProvider theme={defaultTheme}>{element}</ThemeProvider>
}
